import { render, staticRenderFns } from "./UploadProjection.vue?vue&type=template&id=2d71b73a"
import script from "./UploadProjection.vue?vue&type=script&lang=js"
export * from "./UploadProjection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports